module.exports = __webpack_public_path__ + "static/media/ic_info_retiro_extraordinario.6ea6986c.svg";